'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$rootScope", "$scope", "TrainTypeService", "MonitoringStoreService", "FilterStorage", "ProjectService", "ConfigurationStoreService", "$injector", "$state",
 function InformationMonitoringViewController(
    $rootScope,
    $scope,
    TrainTypeService,
    MonitoringStoreService,
    FilterStorage,
    ProjectService,
    ConfigurationStoreService,
    $injector,
    $state) {

    var vm = this;

    vm.actualTrains;
    vm.adjustRefreshCheckbox = adjustRefreshCheckbox;
    vm.adjustFilter = adjustFilter;
    vm.adjustFilterCheckbox = adjustFilterCheckbox;
    vm.adjustServiceFilter = adjustServiceFilter;
    vm.resetFilters = resetFilters;

    vm.customTrainTypeNames;

    vm.connServerObjects;
    vm.connectivityServers;
    vm.teleServerObjects;
    vm.telemetryServers;

    vm.filtersConfig = {
        "searchForAlarm": true,
        "alarmSeverity": true,
        "trainStatus": true,
        "inService": true,
        "opened": false,
        "outsideDepot": true,
        "trainType": true,
        "maintainers": true,
        "maintenanceBoxes": true,
        "currentService": true,
        "nextService": true,
        "showOfflineScheduledTrains": true
    };
    /* showOfflineScheduledTrains config property actually does not affect filters on the screen,
    * it is to control whether to show the trains having unacknowledged 'in-service-offline' alarm(s) */

    var projectId = $state.params && $state.params.projectId;

    var currentFilters = {};
    var alarmTheoreticLevels = {
        1: {
            color: "#D6F6FF",
            label: "I18N_FILTER.INFORMATIONAL",
            level: 1,
            checked: true
        },
        2: {
            color: "#FFFF00",
            label: "I18N_FILTER.LOW_SEVERITY",
            level: 2,
            checked: true
        },
        3: {
            color: "#rgb(255, 180, 0)",
            label: "I18N_FILTER.MEDIUM_SEVERITY",
            level: 3,
            checked: true
        },
        4: {
            color: "#FF3333",
            label: "I18N_FILTER.HIGH_SEVERITY",
            level: 4,
            checked: true
        },
        5: {
            color: "red",
            label: "I18N_FILTER.FATAL_SEVERITY",
            level: 5,
            checked: true
        },
        7: {
            color: "945ABF",
            label: "I18N_FILTER.TRAIN_FAILURE",
            level: 7,
            checked: true
        }
    };
    $rootScope.$on('reload-trains', function() {
        init();
    });
    $rootScope.$on('menu-changed', function() {
        init();
    });
    $rootScope.$on('trains-updated', function() {
        init();
    });

    init();
    var filter = FilterStorage.get('monitoring-filters');
    if (filter) filter.showOfflineScheduledTrains = vm.filtersConfig.showOfflineScheduledTrains;
    MonitoringStoreService.setFilters(filter);

    function init() {
        vm.alarmKeyword = undefined;
        vm.alarmLevels = undefined;
        vm.alarmACKStatuses = undefined;
        vm.inCommercialServiceTrips = false;
        vm.openedForServiceTrips = false;
        vm.outsideDepot = false;
        vm.autoRefresh = true;

        vm.trainTypeObjects = undefined;
        vm.maintainersObjects = undefined;
        vm.maintainers = undefined;
        vm.serviceIdsObjects = undefined;
        vm.serviceIds = undefined;
        vm.currentServiceIds = undefined;
        vm.nextServiceIds = undefined;
        vm.trainTypeData = undefined;
        vm.connServerObjects = undefined;
        vm.connectivityServers = undefined;
        vm.teleServerObjects = undefined;
        vm.telemetryServers = undefined;

        updateFiltersConfig(projectId);
        getTrainsData(projectId);
    }

    function resetFilters() {
        FilterStorage.deleteAll('monitoring-filters');

        FilterStorage.deleteAll('noc-filter-undefined');
        FilterStorage.clear();

        MonitoringStoreService.setFilters(noFilters());

        init();
    }

    function noFilters() {
        return {
            alarmKeyword: undefined,
            alarmLevels: [],
            alarmACKStatuses: [],

            maintainers : [],
            serviceIds : [],

            connectivityServers : [],
            telemetryServers : [],

            inCommercialServiceTrips : false,
            openedForServiceTrips : false,

            outsideDepot : false,
            trainTypeData : []
        };
    }

    function getTrainsData(projectId) {
        var unfilteredTrains = MonitoringStoreService.getUnfilteredTrains(projectId);
        processFetchedTrains(unfilteredTrains);

        var actualTrains = MonitoringStoreService.getTrains(projectId);
        updateTrainCounters(actualTrains);
    }

    $scope.$watch('vm.alarmKeyword', function (newValue) {
        vm.alarmKeyword = newValue;
        if (util.isDefined(newValue)) {
            adjustFilter();
        }
    }, true);



    /*
     FUNCTIONS
     */


    function adjustFilter() {
        currentFilters = processFilters();
        MonitoringStoreService.setFilters(currentFilters);
    }

    function updateFiltersConfig(projectId) {

        var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( projectId );

        if (projectConfiguration && projectConfiguration.hasOwnProperty("alarmFiltersConfiguration")
            && projectConfiguration.alarmFiltersConfiguration && !angular.equals(vm.filtersConfig, projectConfiguration.alarmFiltersConfiguration)) {

            Object.assign(vm.filtersConfig, projectConfiguration.alarmFiltersConfiguration);
        }
    }

    function adjustServiceFilter() {
        vm.currentServiceIds = vm.currentServiceIds.map(function(serviceId) {
            serviceId.checked = true;
            return serviceId;
        });
        vm.nextServiceIds = vm.nextServiceIds.map(function(serviceId) {
            serviceId.checked = true;
            return serviceId;
        });
        adjustFilter();
    }

    function adjustFilterCheckbox (item) {
        item.checked = !item.checked;
        adjustFilter();
    }

    function adjustRefreshCheckbox() {
        $rootScope.$emit('auto-refresh-changed', vm.autoRefresh);
        $injector.get('monitoringBehaviorSubjectService').inform('reload-trains', vm.autoRefresh);
        adjustFilter();
    }

    function updateTrainCounters(actualTrains) {

        vm.alarmLevels = vm.alarmLevels.map(function(alarmLevel) {
            alarmLevel.count = 0;
            return alarmLevel;
        });

        vm.trainTypeObjects = vm.trainTypeObjects.map(function(trainTypeObject) {
            trainTypeObject.count = 0;
            trainTypeObject.nameWithCount = trainTypeObject.name;
            return trainTypeObject;
        });

        vm.maintainersObjects = vm.maintainersObjects.map(function(maintainerObject) {
            maintainerObject.count = 0;
            maintainerObject.nameWithCount = maintainerObject.name ;
            return maintainerObject;
        });

        vm.serviceIdsObjects = vm.serviceIdsObjects.map(function(serviceIdObject) {
            serviceIdObject.count = 0;
            serviceIdObject.nameWithCount = serviceIdObject.name ;
            return serviceIdObject;
        });

        if (vm.connServerObjects) {
            vm.connServerObjects = vm.connServerObjects.map(function (connServerObj) {
                connServerObj.count = 0;
                connServerObj.nameWithCount = connServerObj.name;
                return connServerObj;
            });
        }

        if (vm.teleServerObjects) {
            vm.teleServerObjects = vm.teleServerObjects.map(function (teleServerObj) {
                teleServerObj.count = 0;
                teleServerObj.nameWithCount = teleServerObj.name;
                return teleServerObj;
            });
        }

        actualTrains.forEach(function(train) {

            if (!train.currentTrip) {
                train.currentTrip = {};
                train.currentTrip.tripId = 'no-service';
            }

            if (!train.nextTrip) {
                train.nextTrip = {};
                train.nextTrip.tripId = 'no-service';
            }

            var indexAlarmLevel = vm.alarmLevels.findIndex(function(alarmLevel){
                return alarmLevel.level === train.severity;
            });

            if (vm.alarmLevels && vm.alarmLevels[indexAlarmLevel]) {
                vm.alarmLevels[indexAlarmLevel].count += 1;
            }

            var trainTypeString = train.trainType;
            var indexTrainType = vm.trainTypeObjects.findIndex(function(trainType){
                var trainTypeObject = TrainTypeService.createTrainTypeObject(trainTypeString);
                return trainType.name === trainTypeObject.name;
            });
            if (indexTrainType > -1) {
                vm.trainTypeObjects[indexTrainType].count += 1;
                vm.trainTypeObjects[indexTrainType].nameWithCount = vm.trainTypeObjects[indexTrainType].name + ' (' + vm.trainTypeObjects[indexTrainType].count + ')';
            }

            var currentMaintainer = train.projectName ? train.projectName + '-' + train.maintainer : train.maintainer;
            var indexMaintainer = vm.maintainersObjects.findIndex(function(maintainer){
                return maintainer.name === currentMaintainer;
            });
            if (indexMaintainer > -1) {
                vm.maintainersObjects[indexMaintainer].count += 1;
                vm.maintainersObjects[indexMaintainer].nameWithCount = vm.maintainersObjects[indexMaintainer].name + ' (' + vm.maintainersObjects[indexMaintainer].count + ')';
            }

            var currentServiceId = train.projectName ?  train.currentTrip && train.projectName + '-' + train.currentTrip.tripId   : train.currentTrip && train.currentTrip.tripId;
            var indexCurrentServiceId =  vm.serviceIdsObjects.findIndex(function(service){
                return service.category === 'current' && service.name === currentServiceId;
            });
            if (indexCurrentServiceId > -1) {
                vm.serviceIdsObjects[indexCurrentServiceId].count += 1;
                vm.serviceIdsObjects[indexCurrentServiceId].nameWithCount = vm.serviceIdsObjects[indexCurrentServiceId].name + ' (' + vm.serviceIdsObjects[indexCurrentServiceId].count + ')';
            }

            var nextServiceId =  train.projectName ?  train.nextTrip &&  train.projectName + '-' + train.nextTrip.tripId : train.nextTrip && train.nextTrip.tripId;
            var indexNextServiceId =  vm.serviceIdsObjects.findIndex(function(service){
                return service.category === 'next' && service.name === nextServiceId;
            });
            if (indexNextServiceId > -1) {
                vm.serviceIdsObjects[indexNextServiceId].count += 1;
                vm.serviceIdsObjects[indexNextServiceId].nameWithCount = vm.serviceIdsObjects[indexNextServiceId].name + ' (' + vm.serviceIdsObjects[indexNextServiceId].count + ')';
            }

            if (vm.connServerObjects) {
                var indexConnSrvr = vm.connServerObjects.findIndex(function(connServer){
                    return connServer.name === train.connectivityServer;
                });
                if (indexConnSrvr > -1) {
                    vm.connServerObjects[indexConnSrvr].count += 1;
                    vm.connServerObjects[indexConnSrvr].nameWithCount = vm.connServerObjects[indexConnSrvr].name + ' (' + vm.connServerObjects[indexConnSrvr].count + ')';
                }
            }

            if (vm.teleServerObjects) {
                var indexTeleSrvr = vm.teleServerObjects.findIndex(function (teleServer) {
                    return teleServer.name === train.telemetryServer;
                });
                if (indexTeleSrvr > -1) {
                    vm.teleServerObjects[indexTeleSrvr].count += 1;
                    vm.teleServerObjects[indexTeleSrvr].nameWithCount = vm.teleServerObjects[indexTeleSrvr].name + ' (' + vm.teleServerObjects[indexTeleSrvr].count + ')';
                }
            }
        });

    }


    function processFetchedTrains (fetchedTrains) {

        vm.customTrainTypeNames = TrainTypeService.getTrainTypeDisplayNameObjects(fetchedTrains);

        var minOfficialId = Number.POSITIVE_INFINITY;
        var maxOfficialId = -1;
        var trainTypeEntities = {};
        var trainTypeObjectEntities = {};
        var maintainerEntities = {};
        var serviceIdEntities = {
            current: {},
            next: {}
        };
        var alarmLevelsEntities = {};
        var trainStatuses = {};
        var connServerEntities = {};
        var teleServerEntities = {};

        fetchedTrains.forEach(function (train) {
            if(minOfficialId > train.officialId) {
                minOfficialId = parseInt(train.officialId);
            }
            if(maxOfficialId < train.officialId) {
                maxOfficialId = parseInt(train.officialId);
            }

            if(trainStatuses[train.alarmAckStyle['background-color']] === undefined) {
                var description = '';
                var id = -1;
                switch (train.alarmAckStyle['background-color']) {
                    case 'LIME':
                    case 'GREEN':
                        description = 'I18N_FILTER.NO_ALARMS';
                        id = 1;
                        break;
                    case 'YELLOW':
                        description = 'I18N_FILTER.ACKED_ALARMS';
                        id = 2;
                        break;
                    case 'RED':
                        description = 'I18N_FILTER.ACTIVE_ALARMS';
                        id = 3;
                        break;
                    case 'GREY':
                        description = 'I18N_FILTER.OFFLINE_10_MINUTES';
                        id = 4;
                        break;
                    case 'BLACK':
                        description = 'I18N_FILTER.OFFLINE_48_HOURS';
                        id = 5;
                        break;
                }

                trainStatuses[train.alarmAckStyle['background-color']] = {
                    background: train.alarmAckStyle['background-color'],
                    color: train.alarmAckStyle['color'],
                    checked: true,
                    description: description,
                    id: id
                };
            }


            if((train.severity > 0) && (!alarmLevelsEntities[train.severity])) {
                var checkedAlarmLevel;
                if (!currentFilters.alarmLevels) {
                    checkedAlarmLevel = true;
                } else {
                    checkedAlarmLevel = currentFilters.alarmLevels.find(function(alarmLevel) {
                        return alarmLevel === train.severity;
                    }) ? true : false;
                }
                alarmLevelsEntities[train.severity] = Object.assign({},
                    alarmTheoreticLevels[train.severity], {
                    'checked': checkedAlarmLevel
                });
            }


            if (!train.currentTrip) {
                train.currentTrip = {};
                train.currentTrip.tripId = train.projectName ? train.projectName + '-' + 'no-service' : 'no-service';
            } else {
                var trainCurrentTripId = train.projectName ? train.projectName + '-' + train.currentTrip && train.currentTrip.tripId : train.currentTrip && train.currentTrip.tripId;
                if (trainCurrentTripId && !serviceIdEntities['current'][trainCurrentTripId ]) {
                    var checkedServiceId = false;
                    if (!currentFilters.serviceIds) {
                        checkedServiceId = false;
                    } else {
                        checkedServiceId = currentFilters.serviceIds.find(function(service) {
                                    return service.category === 'current' && service.serviceId === trainCurrentTripId;
                        }) ? true : false;
                    }
                    serviceIdEntities['current'][trainCurrentTripId] = {
                                'name': trainCurrentTripId ,
                                'checked': checkedServiceId,
                    };
                }

            }


            if (!train.nextTrip) {
                train.nextTrip = {};
                train.nextTrip.tripId = train.projectName ? train.projectName + '-' + 'no-service' : 'no-service';
            } else {
                var trainNextTripId = train.projectName ? train.projectName + '-' + train.nextTrip && train.nextTrip.tripId : train.nextTrip && train.nextTrip.tripId;
                if (trainNextTripId && !serviceIdEntities['next'][trainNextTripId]) {
                    if (!currentFilters.serviceIds) {
                        checkedServiceId = false;
                    } else {
                        checkedServiceId = currentFilters.serviceIds.find(function(service) {
                                    return service.category === 'next' && service.serviceId === trainNextTripId;
                        }) ? true : false;
                    }
                    serviceIdEntities['next'][trainNextTripId] = {
                                'name': trainNextTripId,
                                'checked': checkedServiceId
                    };
                }

            }


            var trainTypeString = train.trainType;
            if (trainTypeString && !trainTypeEntities[trainTypeString]) {
                trainTypeEntities[trainTypeString] = true;
                var trainTypeObject = TrainTypeService.createTrainTypeObject(trainTypeString);
                var trainTypeName = trainTypeObject.name;
                if(trainTypeName) {
                    trainTypeObjectEntities[trainTypeName] = Object.assign({}, trainTypeObject, {'checked': true });
                }
            }

            var trainMaintainer = train.projectName ? train.projectName + '-' + train.maintainer : train.maintainer;
            if (trainMaintainer) {
                if(!maintainerEntities[trainMaintainer]) {
                    var checkedMaintainer = false;
                    if (!currentFilters.maintainers) {
                            checkedMaintainer = true;
                    } else {
                            checkedMaintainer = currentFilters.maintainers.find(function(maintainer) {
                                return maintainer === trainMaintainer;
                            }) ? true : false;
                    }
                    maintainerEntities[trainMaintainer] = {
                            'name': trainMaintainer,
                            'checked': checkedMaintainer
                    };
                }
            }

            var trainConnServer = train.connectivityServer;
            if (trainConnServer) {
                if(!connServerEntities[trainConnServer]) {
                    var checkedConnServer = false;
                    if (!currentFilters.connectivityServers) {
                        checkedConnServer = true;
                    } else {
                        checkedConnServer = currentFilters.connectivityServers.find(function(connServer) {
                            return connServer === trainConnServer;
                        }) ? true : false;
                    }
                    connServerEntities[trainConnServer] = {
                        'name': trainConnServer,
                        'checked': checkedConnServer
                    };
                }
            }

            var trainTeleServer = train.telemetryServer;
            if (trainTeleServer) {
                if(!teleServerEntities[trainTeleServer]) {
                    var checkedTeleServer = false;
                    if (!currentFilters.telemetryServers) {
                        checkedTeleServer = true;
                    } else {
                        checkedTeleServer = currentFilters.telemetryServers.find(function(teleServer) {
                            return teleServer === trainTeleServer;
                        }) ? true : false;
                    }
                    teleServerEntities[trainConnServer] = {
                        'name': trainTeleServer,
                        'checked': checkedTeleServer
                    };
                }
            }
        }); // fetchedTrains forEach ends here

        if(!vm.maintainersObjects) {
            vm.maintainersObjects = [];
            Object.keys(maintainerEntities).forEach(function(maintainerKey) {
                vm.maintainersObjects.push(maintainerEntities[maintainerKey]);
            });
        }

        if(!vm.serviceIdsObjects) {
            vm.serviceIdsObjects = [];
            Object.keys(serviceIdEntities).forEach(function(serviceCategory) {
                var currentCategoryServiceIdsObjects = Object.keys(serviceIdEntities[serviceCategory]).map(function(serviceIdKey) {
                    return Object.assign({}, serviceIdEntities[serviceCategory][serviceIdKey], {
                        'category': serviceCategory
                    });
                });
                vm.serviceIdsObjects = vm.serviceIdsObjects.concat(currentCategoryServiceIdsObjects);
            });
        }

        if(!vm.connServerObjects && Object.keys(connServerEntities).length !== 0) {
            vm.connServerObjects = [];
            Object.keys(connServerEntities).forEach(function(connSrvrKey) {
                vm.connServerObjects.push(connServerEntities[connSrvrKey]);
            });
        }

        if(!vm.teleServerObjects && Object.keys(teleServerEntities).length !== 0) {
            vm.teleServerObjects = [];
            Object.keys(teleServerEntities).forEach(function(teleSrvrKey) {
                vm.teleServerObjects.push(teleServerEntities[teleSrvrKey]);
            });
        }

        vm.alarmLevels = Object.keys(alarmLevelsEntities).map(function(level) {
            return alarmLevelsEntities[level];
        });

        vm.alarmACKStatuses = Object.keys(trainStatuses).map(function(optionKey) {
            return trainStatuses[optionKey];
        });

        if(!vm.trainTypeObjects) {
            vm.trainTypeObjects = [];
            Object.keys(trainTypeObjectEntities).forEach(function(key) {
                vm.trainTypeObjects.push(trainTypeObjectEntities[key]);
            });
        }

        if (fetchedTrains && fetchedTrains.length > 0) {
            var filter = FilterStorage.get('monitoring-filters');
            initFilter(filter);
        }
    }

    function initFilter(filter) {
        vm.autoRefresh = filter ? filter.autoRefresh  : vm.autoRefresh;
        $injector.get('monitoringBehaviorSubjectService').inform('init-auto-refresh', vm.autoRefresh);
        vm.alarmKeyword = filter ? filter.alarmKeyword  : vm.alarmKeyword;
        vm.inCommercialServiceTrips = filter ? filter.inCommercialServiceTrips : vm.inCommercialServiceTrips;
        vm.openedForServiceTrips = filter ? filter.openedForServiceTrips :  vm.openedForServiceTrips;
        vm.outsideDepot = filter ? filter.outsideDepot : vm.outsideDepot;
        vm.maintainers = vm.maintainersObjects.filter(function(maintainerObject) {
            return (filter && filter.maintainers) ? !!filter.maintainers.find(function(maintainer) {
                return maintainer === maintainerObject.name;
            }) : false;
        });

        var serviceIds = filter && filter.serviceIds;
        var currentServiceIdsObjects = vm.serviceIdsObjects.filter(function(serviceIdObject) {
            return serviceIdObject.category === 'current';
        });

        vm.currentServiceIds = currentServiceIdsObjects.filter(function(serviceIdObject) {
            var currentServiceIds = serviceIds && serviceIds.filter(function(serviceId) {
                return serviceId.category === 'current';
            });
            return currentServiceIds ? !!currentServiceIds.find(function(service) {
                return service.serviceId === serviceIdObject.name;
            }) : false;
        }).map(function(serviceId) {
            serviceId.checked = true;
            return serviceId;
        });

        var nextServiceIdsObjects = vm.serviceIdsObjects.filter(function(serviceIdObject) {
            return serviceIdObject.category === 'next';
        });

        vm.nextServiceIds = nextServiceIdsObjects.filter(function(serviceIdObject) {
            var nextServiceIds = serviceIds && serviceIds.filter(function(serviceId) {
                return serviceId.category === 'next';
            });
            return nextServiceIds ? !!nextServiceIds.find(function(service) {
                return service.serviceId === serviceIdObject.name;
            }) : false;
        }).map(function(serviceId) {
            serviceId.checked = true;
            return serviceId;
        });

        if (vm.connServerObjects) {
            vm.connectivityServers = vm.connServerObjects.filter(function (connServerObj) {
                return (filter && filter.connectivityServers) ? !!filter.connectivityServers.find(function (connServer) {
                    return connServer === connServerObj.name;
                }) : false;
            });
        }

        if (vm.teleServerObjects) {
            vm.telemetryServers = vm.teleServerObjects.filter(function (teleServerObj) {
                return (filter && filter.telemetryServers) ? !!filter.telemetryServers.find(function (teleServer) {
                    return teleServer === teleServerObj.name;
                }) : false;
            });
        }

        vm.alarmLevels = vm.alarmLevels.map(function (alarmLevel) {
            alarmLevel.checked = filter ? !!filter.alarmLevels.find(function(selectedAlarmLevel) {
                return selectedAlarmLevel === alarmLevel.level;
            }) : false;
            return alarmLevel;
        });

        vm.alarmACKStatuses = vm.alarmACKStatuses.map(function (alarmACKStatus) {
            alarmACKStatus.checked = filter && filter.alarmACKStatuses ? !!filter.alarmACKStatuses.find(function(selectedACKStatus) {
                return selectedACKStatus === alarmACKStatus.background;
            }) : false;
            return alarmACKStatus;
        });

        vm.trainTypeData = vm.trainTypeObjects.filter(function(trainTypeObject) {
            return (filter && filter.trainTypeData) ? !!filter.trainTypeData.find(function(trainType) {
                return trainType === trainTypeObject.name;
            }) : false;
        });
    }

    function processFilters() {
        vm.serviceIds = vm.currentServiceIds.concat(vm.nextServiceIds);
        var filter = {
            autoRefresh: vm.autoRefresh,
            alarmKeyword: vm.alarmKeyword,
            alarmLevels: vm.alarmLevels ?  vm.alarmLevels.filter(function (alarmLevel) {
                return alarmLevel.checked;
            }).map(function(alarmLevel) {
                return alarmLevel.level;
            }) : [],
            alarmACKStatuses: vm.alarmACKStatuses ? vm.alarmACKStatuses.filter(function (alarmStatus) {
                return alarmStatus.checked;
            }).map(function(alarmStatus) {
                return alarmStatus.background;
            }) : [],
            maintainers: vm.maintainers ? vm.maintainers.filter(function (value) {
                return true;
            }).map(function(maintainer) {
                return maintainer.name;
            }) : [],
            serviceIds: vm.serviceIds ? vm.serviceIds.filter(function (value) {
                return value.checked;
            }).map(function(serviceId) {
                return {
                    serviceId: serviceId.name,
                    category: serviceId.category
                };
            }) : [],
            connectivityServers: vm.connectivityServers ? vm.connectivityServers.filter(function (value) {
                return true;
            }).map(function(connServer) {
                return connServer.name;
            }) : [],
            telemetryServers: vm.telemetryServers ? vm.telemetryServers.filter(function (value) {
                return true;
            }).map(function(teleServer) {
                return teleServer.name;
            }) : [],
            inCommercialServiceTrips: vm.inCommercialServiceTrips,
            openedForServiceTrips: vm.openedForServiceTrips,
            outsideDepot: vm.outsideDepot,
            trainTypeData: vm.trainTypeData ? vm.trainTypeData.map(function(trainType) {
                return trainType.name;
            }) : undefined,

            showOfflineScheduledTrains: vm.filtersConfig.showOfflineScheduledTrains,
        };

        FilterStorage.putAll('monitoring-filters', filter);

        return filter;
    }

}];
